export default {
  methods: {
    compareProperties(a, b) {
      return a.key === b.key && a.value === b.value && a.locale === b.locale;
    },
  },
};
